import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const CustomerInvoicePrint = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { invoiceData, ispOwnerData } = props;

  const InvoiceContent = () => (
    <div
      className="position-relative"
      style={{ minHeight: "400px", lineHeight: "0.95" }}
    >
      <div
        className={`position-absolute top-50 start-50 text-uppercase fw-bold display-1 opacity-25 ${
          invoiceData?.paymentStatus === "paid" ? "text-success" : "text-danger"
        }`}
        style={{
          fontSize: "6rem",
          transform: "translate(-50%, -50%) rotate(-25deg)",
          pointerEvents: "none",
          userSelect: "none",
          zIndex: 999,
          whiteSpace: "nowrap",
        }}
        aria-hidden="true"
      >
        {invoiceData?.paymentStatus || "N/A"}
      </div>

      <div className="position-relative z-1">
        <div className="d-flex justify-content-between align-items-start pb-3">
          <div style={{ lineHeight: "0.95" }}>
            <h1 className="h4 fw-bold">{ispOwnerData?.company}</h1>
            <p className="mb-1 small">{ispOwnerData?.address}</p>
            <p className="mb-1 small">Email: {ispOwnerData?.email}</p>
            <p className="small">
              {ispOwnerData?.signature
                ? ispOwnerData?.signature
                : ispOwnerData.mobile}
            </p>
          </div>
        </div>

        <div>
          <p className="userNameStyle text-light mb-0 report5_5">
            <span>{invoiceData?.customer?.name}</span>
            <span>Customer Information</span>
          </p>

          <div className="report5_5 collectReport">
            <div>
              <p>
                <span className="fw-semibold">Mobile Number: </span>
                {invoiceData?.customer?.mobile}
              </p>
              <p>
                <span className="fw-semibold">Client ID: </span>
                {invoiceData?.customer?.customerId}
              </p>
              <p>
                <span className="fw-semibold">Address: </span>
                {invoiceData?.customer?.address}
              </p>
              <p>
                <span className="fw-semibold">Email: </span>
                {invoiceData?.customer?.email}
              </p>
            </div>

            <div>
              <p>
                <span className="fw-semibold">Connection Type: </span>
                {invoiceData?.customer?.userType.toUpperCase()}
              </p>
              <p>
                <span className="fw-semibold">Connection Date: </span>
                {invoiceData?.customer?.connectionDate
                  ? moment(invoiceData?.customer?.connectionDate).format(
                      "MMMM YYYY",
                    )
                  : "N/A"}
              </p>
              <p>
                <span className="fw-semibold">Expire Date: </span>
                {moment(invoiceData.billingCycle).format("YYYY-MM-DD hh:mm A")}
              </p>
              <p>
                <span className="fw-semibold">Month: </span>
                <b>{invoiceData?.month}</b>
              </p>
            </div>
          </div>
        </div>

        <div>
          <p className="userNameStyle text-light mb-0 report5_5">
            <span>{invoiceData?.name}</span>
            <span>Invoice Information</span>
          </p>
          <div className="report5_5 collectReport">
            <div className="reportOptions gt-1">
              <p>
                {t("amount")}
                <b>{invoiceData?.amount}</b>
              </p>
              <p>
                {t("billType")} <b>{invoiceData?.billType}</b>
              </p>
              <p>
                {t("medium")} <b>{invoiceData?.medium}</b>
              </p>
              <p>
                {t("discount")} <b>{invoiceData?.discount}</b>
              </p>
              <p>
                {t("due")} <b>{invoiceData?.due}</b>
              </p>
              <p>
                {t("previousBalance")}
                <b>{invoiceData?.prevState?.balance || 0}</b>
              </p>
              <p>
                {t("currentBalance")}
                <b>{invoiceData?.currentState?.balance || 0}</b>
              </p>
            </div>

            <div className="reportOptions">
              {/* customer bill report create date */}
              <p>
                {t("createDate")}
                <b>
                  {moment(invoiceData.createdAt).format("MMM DD YYYY hh:mm A")}
                </b>
              </p>
              {/* customer previous billing & promise date state */}
              <p className="clintTitle border border-1 ps-1">
                {t("previousState")}
              </p>
              <p className="mt-1">
                {t("billDate")}
                <b className="text-secondary">
                  {moment(invoiceData?.prevState?.billingCycle).format(
                    "MMM DD YYYY hh:mm A",
                  )}
                </b>
              </p>
              <p>
                {t("promiseDate")}
                <b className="text-secondary">
                  {moment(invoiceData?.prevState?.promiseDate).format(
                    "MMM DD YYYY hh:mm A",
                  )}
                </b>
              </p>

              {/* customer current billing & promise date state */}
              <p className="clintTitle border border-1 ps-1 mt-1">
                {t("currentState")}
              </p>
              <p className="mt-1">
                {t("billDate")}
                <b className="text-secondary">
                  {moment(invoiceData?.currentState?.billingCycle).format(
                    "MMM DD YYYY hh:mm A",
                  )}
                </b>
              </p>
              <p>
                {t("promiseDate")}
                <b className="text-secondary">
                  {moment(invoiceData?.currentState?.promiseDate).format(
                    "MMM DD YYYY hh:mm A",
                  )}
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div
        ref={ref}
        className="d-flex justify-content-center align-items-center"
      >
        <div
          className="bg-white rounded-3 w-100 mw-75"
          style={{ lineHeight: "0.95" }}
        >
          <InvoiceContent showButtons={true} showInvoiceId={true} />

          {invoiceData?.status === "both" && (
            <>
              <hr className="my-4" style={{ borderStyle: "dotted" }} />

              <InvoiceContent showButtons={false} showInvoiceId={true} />
            </>
          )}
        </div>
      </div>
    </>
  );
});
export default CustomerInvoicePrint;
